import { useRef } from "react";
import Category from "./Category";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/outline";

function CategoryShow() {
  const ref = useRef(null);

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };
  const category = [
    "Kategori",
    "Semua",
    "kesehatan",
    "Makanan & Minuman",
    "Emas",
    "electronics",
    "jewelery",
    "men's clothing",
    "women's clothing",
    "Dapur",
    "Top up",
    "Tagihan",
    "Handphone",
    "Sport",
    "Ball",
  ];

  return (
    <div className="relative group">
      <button
        onClick={() => scroll(-200)}
        className="absolute top-1/4 -left-4 p-1 border rounded-full bg-white shadow-lg hover:shadow-xl group-hover:inline"
      >
        <ChevronLeftIcon className="h-4" />
      </button>
      <button
        onClick={() => scroll(200)}
        className="absolute top-1/4 -right-4 p-1 border rounded-full bg-white shadow-lg hover:shadow-xl"
      >
        <ChevronRightIcon className="h-4" />
      </button>
      <div
        className="flex space-x-4 overflow-x-scroll whitespace-nowrap scrollbar-hide mt-3"
        ref={ref}
      >
        {category.map((title, index) => (
          <Category title={title} key={index} />
        ))}
      </div>
    </div>
  );
}

export default CategoryShow;
